import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { SapSubmittalRequestDialogComponent } from '../sap-submittal-request-dialog/sap-submittal-request-dialog.component';

@Component({
  selector: 'app-sap-submittal-policy-violation',
  imports: [
    MatIcon,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    TranslatePipe,
    MatButtonModule
  ],
  templateUrl: './sap-submittal-policy-violation.component.html',
  styleUrl: './sap-submittal-policy-violation.component.scss'
})
export class SapSubmittalPolicyViolationComponent {

  constructor(
    private readonly dialog: MatDialog,
    private dialogRef: MatDialogRef<SapSubmittalPolicyViolationComponent>
  ) {}

  openSapSubmittalRequestDialog() {
    this.dialogRef.close();
    
    this.dialog.open(SapSubmittalRequestDialogComponent, {
      width: '600px',
      disableClose: true
    });

  }

}
